import React from "react";
import { Modal, Button } from "react-bootstrap";

import "./deleteSectionModal.css";

const DeleteSectionModal = ({ show, onHide, section, onConfirm }) => {
  const handleConfirm = () => {
    onConfirm();
  };

  if (!section) return null;

  const hasSubsections = section.subsections && section.subsections.length > 0;

  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      className="delete-section-modal"
    >
      <Modal.Body className="pt-0 pb-2">
        <Modal.Header className="modal-title-with-border mb-0" closeButton>
          <Modal.Title>Delete Section?</Modal.Title>
        </Modal.Header>
        <Modal.Body className="pb-0">
          <div>
            {hasSubsections ? (
              <ul className="list-unstyled mb-0">
                <li className="mb-2">• This section contains subsections.</li>
                <li>• Deleting it will also remove all its subsections.</li>
              </ul>
            ) : (
              <p className="mb-0">
                Are you sure you want to delete the section "{section.name}"?
              </p>
            )}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="outline-secondary" onClick={onHide}>
            Cancel
          </Button>
          <Button variant="danger" onClick={handleConfirm}>
            Delete
          </Button>
        </Modal.Footer>
      </Modal.Body>
    </Modal>
  );
};

export default DeleteSectionModal;
